import { browserLocalPersistence, onAuthStateChanged, setPersistence, signOut } from "firebase/auth";
import { auth } from "../firebase";

let authBootstrapped = false;
let authBootstrapPromise = null;

function waitForInitialAuthState() {
  if (authBootstrapped) return Promise.resolve(auth.currentUser);
  if (!authBootstrapPromise) {
    authBootstrapPromise = new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(
        auth,
        (user) => {
          authBootstrapped = true;
          unsubscribe();
          resolve(user || null);
        },
        () => {
          authBootstrapped = true;
          unsubscribe();
          resolve(auth.currentUser || null);
        }
      );
    });
  }
  return authBootstrapPromise;
}

export function getStoredEmployee() {
  try {
    const raw = localStorage.getItem("employee");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export async function clearPanelSession() {
  localStorage.removeItem("employee");
  try {
    await signOut(auth);
  } catch {
    // Ignore logout cleanup failures so the UI can still recover.
  }
}

export async function enablePanelSessionPersistence() {
  await setPersistence(auth, browserLocalPersistence);
}

export async function ensurePanelAdminSession(options = {}) {
  const { forceRefresh = false } = options;
  await waitForInitialAuthState();

  const employee = getStoredEmployee();
  const user = auth.currentUser;
  if (!employee || !user) {
    await clearPanelSession();
    throw new Error("Session expired. Please login again.");
  }

  if (forceRefresh) {
    await user.getIdToken(true);
  }

  const tokenResult = await user.getIdTokenResult();
  const claims = tokenResult?.claims || {};
  const isAdmin = claims.admin === true || claims.super_admin === true;
  if (!isAdmin) {
    await clearPanelSession();
    throw new Error("Authenticated admin required. Please login again.");
  }

  return { employee, user, claims };
}

export function onPanelAuthChange(callback) {
  return onAuthStateChanged(auth, (user) => {
    callback({
      user: user || null,
      employee: getStoredEmployee(),
    });
  });
}
